import { List, Map } from "immutable";

import { Dispatch } from "common/types";

import SessionReport from "seneca-common/features/session/models/SessionReport";
import {
  applyCompleteSessionEventToCourseStat,
  receiveReconciledCourseStudyStats,
  transformServerCourseStat
} from "seneca-common/features/stats/state";

export const reconcileCourseStudyStats = (
  sessionReports: List<SessionReport>,
  courseStats: Record<string, any>,
  reconciledProficiencies: Map<string, number>,
  dispatch: Dispatch
) => {
  const reconciledStudyStats = {
    ...courseStats,
    stats: courseStats.stats
      .map(transformServerCourseStat)
      .map((courseStat: any) => {
        let newStat = courseStat;

        const relevantSessionFinishedEvents =
          getRelevantSessionFinishedEventsForCourse(
            courseStat.courseId,
            sessionReports
          );

        relevantSessionFinishedEvents.forEach((event: any) => {
          newStat = applyCompleteSessionEventToCourseStat(newStat, event!);
        });
        newStat = newStat.set(
          "proficiency",
          reconciledProficiencies.get(courseStat.courseId)
        );
        return newStat;
      })
  };

  // @ts-ignore
  dispatch(receiveReconciledCourseStudyStats(reconciledStudyStats));
};

const getRelevantSessionFinishedEventsForCourse = (
  courseId: string,
  sessionReports: List<SessionReport>
) => {
  return sessionReports
    .filter(report => report.session!.courseId === courseId)
    .map(report => report.session);
};
